/* =========================================================
   NÉBULA — JS propio (vanilla, sin librerias externas)
   ========================================================= */

function nbInitReveals() {
  var els = document.querySelectorAll('.nb-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('nb-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('nb-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function nbInitContadores() {
  var els = document.querySelectorAll('[data-nb-contador]');
  if (!els.length) return;
  var animar = function (el) {
    var fin = parseFloat(el.getAttribute('data-nb-contador')) || 0;
    var dur = 1400;
    var t0 = null;
    function paso(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var valor = Math.floor(fin * (1 - Math.pow(1 - p, 3)));
      el.textContent = valor.toLocaleString('es-ES') + (el.getAttribute('data-nb-sufijo') || '');
      if (p < 1) requestAnimationFrame(paso);
      else el.textContent = fin.toLocaleString('es-ES') + (el.getAttribute('data-nb-sufijo') || '');
    }
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { animar(entry.target); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}

function nbInitComparadores() {
  var comparadores = document.querySelectorAll('.nb-comparador');
  comparadores.forEach(function (comp) {
    var antes = comp.querySelector('.nb-comparador-antes');
    var asa = comp.querySelector('.nb-comparador-asa');
    if (!antes || !asa) return;
    var arrastrando = false;

    function fijarPct(pct) {
      pct = Math.max(0, Math.min(100, pct));
      antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      asa.style.left = pct + '%';
    }

    function pctDesdeEvento(clientX) {
      var rect = comp.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    asa.addEventListener('pointerdown', function (e) { arrastrando = true; asa.setPointerCapture(e.pointerId); });
    window.addEventListener('pointerup', function () { arrastrando = false; });
    comp.addEventListener('pointerdown', function (e) { arrastrando = true; fijarPct(pctDesdeEvento(e.clientX)); });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      fijarPct(pctDesdeEvento(e.clientX));
    });
    fijarPct(50);
  });
}

function nbInitFaq() {
  var items = document.querySelectorAll('.nb-faq-item');
  items.forEach(function (item) {
    var boton = item.querySelector('.nb-faq-pregunta');
    var resp = item.querySelector('.nb-faq-respuesta');
    if (!boton || !resp) return;
    boton.addEventListener('click', function () {
      var abierto = item.getAttribute('data-abierto') === 'true';
      items.forEach(function (otro) {
        if (otro !== item) {
          otro.setAttribute('data-abierto', 'false');
          otro.querySelector('.nb-faq-respuesta').style.maxHeight = null;
        }
      });
      if (abierto) {
        item.setAttribute('data-abierto', 'false');
        resp.style.maxHeight = null;
      } else {
        item.setAttribute('data-abierto', 'true');
        resp.style.maxHeight = resp.scrollHeight + 'px';
      }
    });
  });
}

function nbInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-nb-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-nb-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-nb-miniatura]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-nb-src');
        var srcset = mini.getAttribute('data-nb-srcset');
        if (src) principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach(function (m) { m.classList.remove('nb-mini-activa'); });
        mini.classList.add('nb-mini-activa');
      });
    });
  });
}

function nbInitVariantes() {
  var forms = document.querySelectorAll('[data-nb-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-nb-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-nb-opcion]');
    var inputId = form.querySelector('[data-nb-variant-id]');
    var precioEl = form.closest('[data-nb-columna-compra]') ? form.closest('[data-nb-columna-compra]').querySelector('[data-nb-precio]') : null;
    var comparadoEl = form.closest('[data-nb-columna-compra]') ? form.closest('[data-nb-columna-compra]').querySelector('[data-nb-precio-comparado]') : null;
    var badgeEl = form.closest('[data-nb-columna-compra]') ? form.closest('[data-nb-columna-compra]').querySelector('[data-nb-descuento-badge]') : null;
    var botonAgregar = form.closest('[data-nb-columna-compra]') ? form.closest('[data-nb-columna-compra]').querySelector('[data-nb-boton-agregar]') : form.querySelector('[data-nb-boton-agregar]');

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function actualizar() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      var encontrada = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === valores[i]; });
      });
      if (!encontrada) return;
      inputId.value = encontrada.id;
      if (precioEl) precioEl.textContent = formatearDinero(encontrada.price);
      if (comparadoEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          comparadoEl.textContent = formatearDinero(encontrada.compare_at_price);
          comparadoEl.style.display = '';
        } else {
          comparadoEl.style.display = 'none';
        }
      }
      if (badgeEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          var pct = Math.round((encontrada.compare_at_price - encontrada.price) / encontrada.compare_at_price * 100);
          badgeEl.textContent = '-' + pct + '%';
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }
      if (botonAgregar) {
        if (encontrada.available) {
          botonAgregar.disabled = false;
          botonAgregar.textContent = botonAgregar.getAttribute('data-nb-texto-disponible') || botonAgregar.textContent;
        } else {
          botonAgregar.disabled = true;
          botonAgregar.textContent = botonAgregar.getAttribute('data-nb-texto-agotado') || 'Agotado';
        }
      }
      if (encontrada.featured_image) {
        var galeria = form.closest('section') ? form.closest('section').querySelector('[data-nb-galeria]') : null;
        if (galeria) {
          var principal = galeria.querySelector('[data-nb-imagen-principal]');
          if (principal) principal.src = encontrada.featured_image;
          var minis = galeria.querySelectorAll('[data-nb-miniatura]');
          var coincide = false;
          minis.forEach(function (m) {
            if (m.getAttribute('data-nb-src') === encontrada.featured_image) {
              m.classList.add('nb-mini-activa');
              coincide = true;
            } else {
              m.classList.remove('nb-mini-activa');
            }
          });
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

// Barra fija de compra (móvil): aparece cuando el botón principal sale de vista.
function nbInitBarraFija() {
  var barra = document.querySelector('[data-nb-barra-fija]');
  var botonPrincipal = document.querySelector('[data-nb-boton-agregar]');
  if (!barra || !botonPrincipal) return;

  var precioOrigen = document.querySelector('[data-nb-precio]');
  var precioDestino = barra.querySelector('[data-nb-barra-precio]');
  var botonDestino = barra.querySelector('[data-nb-barra-boton]');

  function sincronizarPrecio() {
    if (precioOrigen && precioDestino) precioDestino.textContent = precioOrigen.textContent;
  }
  sincronizarPrecio();
  if (precioOrigen && 'MutationObserver' in window) {
    new MutationObserver(sincronizarPrecio).observe(precioOrigen, { childList: true, characterData: true, subtree: true });
  }

  if (botonDestino) {
    botonDestino.addEventListener('click', function () {
      botonPrincipal.click();
    });
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      barra.classList.toggle('nb-barra-fija-visible', !visible);
    }, { threshold: 0 });
    obs.observe(botonPrincipal);
  } else {
    barra.classList.add('nb-barra-fija-visible');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  nbInitReveals();
  nbInitContadores();
  nbInitComparadores();
  nbInitFaq();
  nbInitGaleriaProducto();
  nbInitVariantes();
  nbInitBarraFija();
});
